import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import KriteriaIcuSvc from "@/services/KriteriaIcuService";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "kriteria-icu"
})
class KriteriaIcuModule extends VuexModule {
  currentItem: any = null;
  loading = false;

  @Mutation SET_CURRENT_ITEM(val: any) {
    this.currentItem = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);
    try {
      const dt = await KriteriaIcuSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await KriteriaIcuSvc.find(id);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_CURRENT_ITEM(null);
  }
}

export const storeKriteriaIcu = getModule(KriteriaIcuModule);
